import { createFileRoute } from '@tanstack/react-router';
import { JourneysTransactionalSentHandoff } from '@/pages/workspaces/transactional/message/overview/sent/routing';

export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/journeys/transactional/$transactionalMessageId/overview_/sent/$deliveryId',
)({
  component: JourneysTransactionalSentHandoff,
});
